import { SET_CAMPUSES_VALUE } from "../actions/actionTypes";

const initialState = {
  campuses: null
};

export const campusesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMPUSES_VALUE:
      return {
        ...state,
        campuses: action.campuses
      };
    default:
      return state;
  }
};
